export default __webpack_public_path__ + "static/media/sec-3c.0feb4a40.png";